/**
 * @description scrollTop 按鈕 id 與 時間
 * @param {string} id
 * @param {number} duration
 */
function scrollToTop(id, duration = 300) {
  const el = document.querySelector(id);
  if (el) {
    el.addEventListener('click', () => {
      const cosParameter = window.scrollY / 2;
      let scrollCount = 0;
      let oldTimestamp = null;

      // eslint-disable-next-line consistent-return
      function step(newTimestamp) {
        if (oldTimestamp !== null) {
          // delta = 變化量
          scrollCount += (Math.PI * (newTimestamp - oldTimestamp)) / duration;
          if (scrollCount >= Math.PI) return window.scrollTo(0, 0);
          window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
        }
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    });
  }
}

function scrollAnimation(endY, duration = 500) {
  const startY = window.scrollY;
  const change = endY - startY;
  const startTime = performance.now();

  function animateScroll(currentTime) {
    const elapsedTime = currentTime - startTime;
    const fraction = elapsedTime / duration;

    if (fraction < 1) {
      const newY = startY + change * fraction;
      window.scrollTo(0, newY);
      requestAnimationFrame(animateScroll);
    } else {
      window.scrollTo(0, endY);
    }
  }

  requestAnimationFrame(animateScroll);
}

/**
 * @description scrollTop 按鈕 id 與 顯示高度
 * @param {string} id
 * @param {number} top
 */
function goToTopVisibility(id, top = 500) {
  const el = document.querySelector(id);
  if (el) {
    const { scrollY } = window;
    if (scrollY > top) {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
    } else {
      el.style.opacity = '0';
      el.style.visibility = 'hidden';
    }
  }
}

function useGoToTop() {
  return {
    scrollAnimation,
    scrollToTop,
    goToTopVisibility,
  };
}

export default useGoToTop;
